import React from 'react';
export function GuaranteeSection() {
  return <section className="py-8 px-4 bg-gray-50" data-id="element-48" data-mp="1i4zo0qq39knb">
      <div className="max-w-3xl mx-auto text-center" data-id="element-49" data-mp="4uqd8v2my0ss">
        <img src="https://cdn.magicpatterns.com/uploads/brqUmSz4yCe5C97rvxKRZm/garantia_de_7_dias.jpg" alt="Garantía de 7 días" className="w-32 h-32 mx-auto mb-4 object-contain" data-id="element-50" data-mp="4xck0shpcc9y" />

        <h2 className="text-2xl md:text-3xl font-black text-gray-900 mb-3" data-id="element-51" data-mp="jsirzl0cyl5x">
          Garantía de 7 días
        </h2>

        <div className="max-w-2xl mx-auto text-lg text-gray-700 space-y-3" data-id="element-52" data-mp="ntm53zr0u33g">
          <p className="font-medium" data-id="element-53" data-mp="skugh1bwvyj9">
            Queremos que estés 100% conforme con tu compra.
          </p>
          <p data-id="element-54" data-mp="xjntksnadniw">
            Probalo sin riesgo. Si durante los primeros 7 días sentís que el
            material no es para vos, podés solicitar la devolución.
          </p>
          <p className="font-semibold text-gray-900" data-id="element-55" data-mp="12gxjsaii237s">
            Comprá con total tranquilidad: tu inversión está protegida.
          </p>
        </div>
      </div>
    </section>;
}